import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { DeviceContext, deviceType } from "@providers";
import { useQuery } from "@apollo/react-hooks";
import { uiComponent } from "@src/queries/__generated__/uiComponent";
import { UI_COMPONENT } from "@queries";
import { uiComponentVariables } from "@src/core/config";
import { Loading, ProcessAbsoluteUrlForChildren } from "@atoms";
import { Container, Row, Col } from "react-bootstrap";
import { useAlert } from "react-alert";

const BrandStoryPage: React.FC<IProps> = (
  {
    // destructure props here if needed
  }: IProps) => {
  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;
  const alert = useAlert();
  const {data, error} = useQuery<uiComponent>(UI_COMPONENT, {
    variables: uiComponentVariables.brandStory,
  });
  return data && (
    <S.Wrapper>
      <Container>
        <Row>
          {data.uicomponent.items.filter((item) => {
            return item.isActive;
          }).map((brandStory, idx: number) => {
              return (
                <Col xs={12} md={6} key={idx}>
                  <ProcessAbsoluteUrlForChildren url={brandStory.link ? brandStory.link : "#"}>
                    {
                      isMobile ?
                        <img src={brandStory.imageMobileUrl}
                             alt={brandStory.name} style={{width: "100%"}}/>
                        :
                        <img src={brandStory.imageWebUrl}
                             alt={brandStory.name} style={{width: "100%"}}/>
                    }
                    <h2>{brandStory.title}</h2>
                    <p>{brandStory.body}</p>
                  </ProcessAbsoluteUrlForChildren>
                </Col>
              )
            }
          )}
        </Row>
      </Container>
    </S.Wrapper>
  ) || <Loading/>
};

export { BrandStoryPage }